import type { ForecastRun } from '../types'
import SupervisorPanel from './SupervisorPanel'
import { useForecastStore } from '../store/forecastStore'
import './ForecastDetailsPanel.css'

export default function ForecastDetailsPanel({ run }: { run?: ForecastRun | null }) {
  const supervisorStageStarted = useForecastStore((s) => s.supervisorStageStarted)
  const shouldShow = Boolean(run && (run.status === 'complete' || supervisorStageStarted))

  // Don’t show the details section while prediction agents are running (avoids an “empty” pane).
  if (!shouldShow) return null

  return (
    <section className="forecast-details">
      <div className="forecast-details-header">
        <div className="forecast-details-title">Overall aggregate prediction</div>
        <div className="forecast-details-subtitle">Aggregated prediction based on all AI prediction agents.</div>
      </div>
      <div className="forecast-details-body">
        <SupervisorPanel finalResult={run?.final_result} run={run} />
      </div>
    </section>
  )
}


